import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundSize extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Size",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Cover",
          value: "cover",
        },
        {
          label: "Contain",
          value: "contain",
        },
      ],
    },
  };

  static defaultValue = "cover";
}
